// Func = limiting Scope for this file
var lastScrollTop = 0;
//global variables to use in different functions
var w=window,
	d=document,
	e=d.documentElement,
	g=d.getElementsByTagName('body')[0],
	windowW=w.innerWidth||e.clientWidth||g.clientWidth,
	windowH=w.innerHeight||e.clientHeight||g.clientHeight;


var body = document.body,
	html = document.documentElement;

var docHeight = Math.max( body.scrollHeight, body.offsetHeight,
	html.clientHeight, html.scrollHeight, html.offsetHeight );

(function(){



	//header menu items
	// let contentmenu = document.getElementById('floating-menu');

	// document.getElementsByClassName('menu-mobile')[0].addEventListener('click', function(e){
	// 	e.preventDefault();
	// 	contentmenu.classList.remove('active-out');
	// 	contentmenu.classList.add('active-in');
	// });

	// document.getElementsByClassName('close-menu')[0].addEventListener('click', function(e){
	// 	e.preventDefault();
	// 	contentmenu.classList.remove('active-in');
	// 	contentmenu.classList.add('active-out');
	// });

	//booking widget
	let contentbooking = document.getElementById('booking-widget');

	document.getElementsByClassName('book-now')[0].addEventListener('click', function(e){
		e.preventDefault();
		contentbooking.classList.remove('active-out');
		contentbooking.classList.add('active-in');
	});

	document.getElementsByClassName('close-booking')[0].addEventListener('click', function(e){
		e.preventDefault();
		contentbooking.classList.remove('active-in');
		contentbooking.classList.add('active-out');
	});

	//is explorer
	function msieversion() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
		{
			const image_fit = document.getElementsByTagName('figure');
			for(let i = 0; i < image_fit.length; i++ ){
				const this_image = image_fit[i].getElementsByTagName('img')[0];
				const image_data = this_image.dataset.srcset;
				const image_src = this_image.getAttribute('src');
				image_fit[i].classList.add('ie-bg');
				if(image_data){
					image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
				}else{
					image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
				}
			}
		}
		else
		{
			console.log('other browser');
		}
		return false;
	}

	msieversion();

	$(document).ready(function () {

		//Call function with browser is resized.
		//$(window).resize(function (event) {
			//resizeWindow();
		//});
		//resizeWindow();

		//Acts when scroll down page.
		//$(window).scroll(function (event) {
			//scrollDown();
		//});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=new Date($('#CheckIn').val());
			let d2=new Date($('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "mm/dd/yy";
        /*$( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

				$( "#CheckIn-alt" ).val( selectedDate );
				$( "#CheckOut-alt" ).val( ( newDate.getMonth() + 1 ) + "/" + newDate.getDate() + "/" + newDate.getFullYear() );

				$( "input[name=CIM]").val( getDate.getMonth() + 1 );
				$( "input[name=CID]").val(getDate.getDate());
				$( "input[name=CIY]").val(getDate.getFullYear());
				$( "input[name=COM]").val( newDate.getMonth() + 1 );
				$( "input[name=COD]").val(newDate.getDate());
				$( "input[name=COY]").val(newDate.getFullYear());
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				var getDateCheckout = $(this).datepicker('getDate');

				$( "#CheckOut-alt" ).val( ( getDateCheckout.getMonth() + 1 ) + "/" + getDateCheckout.getDate() + "/" + getDateCheckout.getFullYear() );

				$( "input[name=COM]").val( getDateCheckout.getMonth() + 1 );
				$( "input[name=COD]").val(getDateCheckout.getDate());
				$( "input[name=COY]").val(getDateCheckout.getFullYear());
			}
		});*/

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(st < (docHeight - (windowH + 500))){
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}

		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}